import { render, staticRenderFns } from "./TreeWorkspace.vue?vue&type=template&id=204f677e&scoped=true&"
import script from "./TreeWorkspace.vue?vue&type=script&lang=js&"
export * from "./TreeWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./TreeWorkspace.vue?vue&type=style&index=0&id=204f677e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f677e",
  null
  
)

export default component.exports